import { render } from "./DFormRow.vue?vue&type=template&id=08ecc98c&scoped=true"
import script from "./DFormRow.vue?vue&type=script&lang=js"
export * from "./DFormRow.vue?vue&type=script&lang=js"

import "./DFormRow.vue?vue&type=style&index=0&id=08ecc98c&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ecc98c"]])

export default __exports__